<mat-tab>
  <ng-template mat-tab-label>
    @if (tab.icon) {
      <ng-icon [name]="tab.icon"></ng-icon>
    }
    {{ tab.label }}
  </ng-template>
  <div class="tab-content">
    <ng-container *ngComponentOutlet="tab.component"></ng-container>
  </div>
</mat-tab>
